let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1T5xx")).then(() => parcelRequire('5l5CZ'));